import { Icon, Spinner } from "@atoms";
import { BrightnessType, SizeType } from "@theme/types";
import { widthMixin } from "@theme/mixins";
import { PRIMARY_BUTTON_SIZE } from "./constants";
import { useState, type CSSProperties } from "react";

export type SecondaryButtonTemplateProps = {
  onClick?: () => void;
  label: string;
  stretch?: boolean;
  autosize?: boolean;
  size?: SizeType;
  withIcon?: "google";
  color: string;
  hoverColor?: string;
  brightness?: BrightnessType;
  type?: "button" | "submit";
  loading?: boolean;
  height?: number;
  width?: number;
  textColor?: string;
  borderColor?: string;
  borderWidth?: number;
  fontWeight?: CSSProperties["fontWeight"];
};

export const SecondaryButtonTemplate = ({
  onClick,
  label,
  stretch,
  autosize,
  size,
  color,
  withIcon,
  type = "button",
  loading,
  hoverColor = "#f3f4f6",
  textColor = "black",
  borderColor = "#bbbbbb",
  borderWidth = 1,
  fontWeight = "normal",
}: SecondaryButtonTemplateProps): JSX.Element => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <button
      type={type}
      className={`${widthMixin({
        table: PRIMARY_BUTTON_SIZE,
        size,
        stretch,
        autosize,
        centered: true,
      })} py-2 px-3 rounded-full min-h-full`}
      style={{
        backgroundColor: isHovered ? hoverColor : color,
        borderStyle: "solid",
        borderColor,
        borderWidth,
        color: textColor,
        fontWeight,
      }}
      {...(onClick && { onClick })}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div style={{height: 25}} className="flex items-center">
        {withIcon ? (
          <div style={{ bottom: 0.5 }} className="mr-3 relative">
            <Icon variant={withIcon} height={15} width={16} />
          </div>
        ) : null}
        {loading ? <Spinner /> : <span>{label}</span>}
      </div>
    </button>
  );
};
